// extracted by mini-css-extract-plugin
module.exports = {"ArticleDate":"ArticleDate_ArticleDate__YZe_I","ArticleDate__Item":"ArticleDate_ArticleDate__Item__7q8_9","ArticleDate__Label":"ArticleDate_ArticleDate__Label__Q65yg"};